<template>
  <div>
    <div class="flex justify-center relative">
      <div class="shadow-2xl mx-8 p-6 bg-white rounded-lg z-10">
        <div>
          <img :src="imageUrl">
        </div>
        <h2 class="md:text-4xl text-3xl text-highlight font-bold mt-2">{{ $rt(step.title) }}</h2>
        <p class="max-img-w mb-4">{{ $rt(step.subTitle) }}</p>
        <img class="expandButton mt-8 pointer"
             :src="isOpen ? imgCollapse : imgExpand"
             alt="Open details" @click="toggleStep()">
      </div>
    </div>

    <div class="bg-darkgray text-white px-5 sm:px-20 shift-y overflow-hidden opacity-0 transition-all duration-500"
         :class="{ 'h-0': !isOpen, 'opacity-100': isOpen, 'py-24': isOpen }">
      <div class="container columns mx-auto">
        <p v-for="(text, index) in step.descriptionTop" :key="`s${stepIndex}descTop${index}`" class="text-white" v-html="$rt(text)" />
        <ul class="ml-4 text-white" >
          <li v-for="(text, index) in step.descriptionOptionsList" :key="`s${stepIndex}opt${index}`"
              v-html="$rt(text)" />
        </ul>
        <p v-for="(text, index) in step.descriptionOptionsDetails" :key="`s${stepIndex}det${index}`" class="text-white"
           v-html="$rt(text)" />
      </div>
    </div>

    <div v-if="$rt(step.operationsWhat)" class="container mx-auto flex flex-col relative shift-y">
      <div class="flex">
        <div class="w-1/2 text-right pr-2 lg:pr-8 ml-4 pt-20 arrow-left operations-tools text-xs break-word lg:text-base">
          <h3>{{ $t('dovesono.operations') }}</h3>
          <p class="w-full md:w-3/4 xl:w-1/2 ml-auto mb-12">{{ $rt(step.operationsWhat) }}</p>
        </div>
        <div class="w-1/2 pl-2 lg:pl-8 pt-20 mr-4 arrow-right operations-tools  text-xs break-word lg:text-base">
          <h3>{{ $t('dovesono.tools') }}</h3>
          <p class="w-full md:w-3/4 xl:w-1/2 mr-auto mb-12">{{ $rt(step.toolsWhat) }}</p>
        </div>
      </div>
      <div class="flex">
        <div class="w-1/2 text-right pr-2 lg:pr-8 ml-4 pb-20 arrow-left operations-tools text-xs break-word lg:text-base">
          <ul>
            <li v-for="(opItem, index) in step.operationsHow" :key="`s${stepIndex}opHow${index}`">
              <a v-if="$rt(opItem.link)" :href="$rt(opItem.link)" target="_blank" class="text-highlight">{{ $rt(opItem.title) }} <img
                class="h-4 lg:h-6 align-bottom" src="~/assets/img/link.svg"></a>
              <span v-else>{{ $rt(opItem.title) }}</span>
            </li>
          </ul>
        </div>
        <div class="w-1/2 pl-2 lg:pl-8 pb-20 mr-4 arrow-right operations-tools text-xs break-word lg:text-base">
          <ul>
            <li v-for="(toolItem, index) in step.toolsHow" :key="`s${stepIndex}opHow${index}`">
              <a v-if="$rt(toolItem.link)" :href="$rt(toolItem.link)" target="_blank" class="text-highlight"><img
                class="h-4 lg:h-6 align-bottom" src="~/assets/img/link.svg"> {{ $rt(toolItem.title) }}</a>
              <span v-else>{{ $rt(toolItem.title) }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="arrowhead" />
    </div>
  </div>
</template>

<script>
import imgCollapse from '~/assets/img/dovesono/btn-collapse.svg'
import imgExpand from '~/assets/img/dovesono/btn-expand.svg'
export default defineNuxtComponent({
  name: 'DoveSonoBlock',
  props: {
    step: {
      type: Object,
      required: true
    },
    stepIndex: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isOpen: false,
      imgCollapse,
      imgExpand,
    }
  },
  computed: {
  },
  methods: {
    toggleStep() {
      this.isOpen = !this.isOpen
    }
  }
})
</script>

<style scoped>
img {
  display: inline;
}

.max-img-w {
  max-width: 538px;
  /* same as img */
}

.expandButton {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
}

.shift-y {
  transform: translateY(-20px);
}

.arrow-left {
  border-right: 1px solid var(--color-darkgray);
}

.arrow-right {
  border-left: 1px solid var(--color-darkgray);
}

.arrowhead {
  width: 20px;
  height: 20px;
  transform: translate(-10px, -1.5px) rotate(45deg);
  border-bottom: 2px solid var(--color-darkgray);
  border-right: 2px solid var(--color-darkgray);
  position: absolute;
  bottom: 0;
  left: 50%;
}

.operations-tools h3 {
  @apply font-bold mb-4;
}

.operations-tools li {
  @apply font-bold;
}
</style>
